import React, { useState, useEffect } from 'react';
import { useDebounce } from 'use-debounce';
import ClipLoader from 'react-spinners/ClipLoader';
import StyleConstants from '../../styles.constants';

interface Props {
  readonly size?: number;
  readonly color?: string;
  readonly delay?: number;
}

const ActivityIndicator = ({ size, color, delay = 0 }: Props): React.JSX.Element => {
  const [show, setShow] = useState(false);
  const [value] = useDebounce(show, delay);

  useEffect(() => {
    setShow(true);
  }, [delay]);

  return value ? <ClipLoader size={size ?? 32} color={color ?? StyleConstants.PRIMARY_BACKGROUND_COLOR} /> : <div />;
};

export default ActivityIndicator;
